<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       class="c-icon-grid"
       viewBox="0 0 14 14"
       width="14"
       height="14">
    <g transform="translate(-297 -196)">
      <rect id="Rectangle_1345"
            data-name="Rectangle 1345"
            width="6"
            height="6"
            transform="translate(297 196)" />
      <rect id="Rectangle_1348"
            data-name="Rectangle 1348"
            width="6"
            height="6"
            transform="translate(305 196)" />
      <rect id="Rectangle_1346"
            data-name="Rectangle 1346"
            width="6"
            height="6"
            transform="translate(297 204)" />
      <rect id="Rectangle_1347"
            data-name="Rectangle 1347"
            width="6"
            height="6"
            transform="translate(305 204)" />
    </g>
  </svg>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'cIconGrid',
});
</script>

<style lang="scss"
       scoped>

.c-icon-grid {
  width: var(--default-icon-width);
  height: var(--default-icon-height);

  rect {
    fill: currentColor;
  }
}
</style>
